import { Link } from '@routable/gross-ds';
import React from 'react';
import { LEGAL_TOS_URL } from 'constants/platform';
const TermsOfServiceLink = ({ className }) => (React.createElement(Link, { className: className, href: LEGAL_TOS_URL, openInNewTab: true, showArrowIcon: false }, "Terms of service"));
export default TermsOfServiceLink;
